import {
  FILTER_TYPE__PROPERTY,
  FILTER_CONDITION__INCLUDE,
  FILTER_CONDITION__EXCLUDE,
  FILTER_CONDITION__DATE_EQUALS,
  FILTER_CONDITION__DATE_NOT_EQUAL,
  FILTER_CONDITION__DATE_SAME_OR_AFTER,
  FILTER_CONDITION__DATE_SAME_OR_BEFORE,
  FILTER_CONDITION__DATE_AFTER,
  FILTER_CONDITION__DATE_BEFORE,
} from '../../../common/constants';
import { FILTER_CATEGORY__OTHER } from '../../../components/Filters';

const defaultFilters = [
  {
    name: 'Project',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__INCLUDE,
    settings: {
      id: 'projectId',
    },
    meta: {
      category: FILTER_CATEGORY__OTHER,
      noSearch: true,
      conditions: [FILTER_CONDITION__INCLUDE],
    },
  },
  {
    name: 'Milestone',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__INCLUDE,
    settings: {
      id: 'milestoneId',
    },
    meta: {
      category: FILTER_CATEGORY__OTHER,
      noSearch: true,
      conditions: [FILTER_CONDITION__INCLUDE, FILTER_CONDITION__EXCLUDE],
    },
  },
  {
    name: 'Questionnaire',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__INCLUDE,
    settings: {
      id: 'questionnaireId',
    },
    meta: {
      category: FILTER_CATEGORY__OTHER,
      noSearch: true,
      conditions: [FILTER_CONDITION__INCLUDE, FILTER_CONDITION__EXCLUDE],
    },
  },
  {
    name: 'Completed date',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__DATE_EQUALS,
    settings: {
      id: 'completedAt',
    },
    meta: {
      category: FILTER_CATEGORY__OTHER,
      conditions: [
        FILTER_CONDITION__DATE_EQUALS,
        FILTER_CONDITION__DATE_NOT_EQUAL,
        FILTER_CONDITION__DATE_SAME_OR_AFTER,
        FILTER_CONDITION__DATE_SAME_OR_BEFORE,
        FILTER_CONDITION__DATE_AFTER,
        FILTER_CONDITION__DATE_BEFORE,
      ],
    },
  },
];

export default defaultFilters;
